import type { FC } from 'types/react';

import { questionnaireEvents } from 'stores/builder/questionnaire';
import { resetBlocksEvent } from 'stores/builder/block/model';
import { Button } from 'ui-kit/components/buttons/Button';
import { Select } from 'ui-kit/components/Select/Select';
import { languages } from 'components/Header/constants';
import { H1 } from 'ui-kit/components/typography/H';
import { useLanguage } from 'hooks/useLanguage';
import { BUILDER_LINK } from 'constants/routes';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-use';
import { useMemo } from 'react';

import { ButtonsContainer, SelectContainer, Container } from './styles';

export const Header: FC = () => {
    const navigate = useNavigate();
    const { pathname = '/dashboard', search } = useLocation();
    const { t } = useTranslation();
    const { setLanguage, language } = useLanguage();

    const title = useMemo(() => {
        const splitPathname = pathname.split('/');

        return splitPathname[splitPathname.length - 1];
    }, [pathname]);

    const goToTheBuilder = () => {
        sessionStorage.setItem('linkToDashBoard', `${pathname}${search}`);
        resetBlocksEvent();
        questionnaireEvents.resetQuestionnaireEvent();
        navigate(BUILDER_LINK);
    };

    return (
        <Container>
            <H1>{t(`dashboard.aside.${title}`)}</H1>
            <ButtonsContainer>
                <SelectContainer>
                    <Select
                        onChange={({ value }: any) => setLanguage(value)}
                        defaultValue={language}
                        isSearchable={false}
                        options={languages}
                    />
                </SelectContainer>
                <Button onClick={goToTheBuilder} variant="primary">
                    {t('dashboard.createANewTemplate')}
                </Button>
            </ButtonsContainer>
        </Container>
    );
};
